import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoutes";
import PublicRoute from "./components/PublicRoutes";
import HasPermission from "./utils/auth";

import Login from "./pages/login";
import Home from "./components/dashboard";
import BeginView from "./components/dashboard/begin";
import UserView from "./components/user";
import Dispenser from "./components/dispenser";
import TurnView from "./components/turnview";
import MedicoView from "./components/medico";
import OfficeView from "./components/offices";
import Paciente from "./components/atencionpac";
import ModuleView from "./components/module";
import MainView from "./components/screen";
import ExpendedorView from "./components/expendedor";
import Pendiente from "./components/pendiente";
import PantallaView from "./components/pantalla";
import AreaView from "./components/area";
import ServiceView from "./components/service";
import MessageView from "./components/message";
import Permission from "./components/permission";
import AsignPermisse from "./components/user/Permise";
import UserImport from "./components/user/import";
import UploadImageView from "./components/upload/images";
import UploadImage from "./components/upload/images/upload";
import UploadVideo from "./components/upload/videos/upload";
import UploadVideoView from "./components/upload/videos";
import InformeAtencDia from "./components/graphics/atendia";
import InformeHistorico from "./components/graphics/historic";
import InformePeriodos from "./components/graphics/fordate";
import InformeAtencHora from "./components/graphics/atenhora";
import InformePromAtencion from "./components/graphics/promaten";
import InformePromEspera from "./components/graphics/promesp";
import InformePromVisita from "./components/graphics/promvisit";
import CompanyView from "./components/company";
function App() {
  const basename = import.meta.env.BASE_URL.replace(/\/$/, "");
  return (
    <Router basename={basename}>
      <Routes>
          <Route element={<PublicRoute />}>
             <Route exact path="/" element={<Login />}></Route>
             <Route exact path="/login" element={<Login />}></Route>
             <Route exact path="/dispenser" element={<Dispenser />}></Route>
             <Route exact path="/screen" element={<MainView />}></Route>
          </Route>  

          <Route path="/"element={<ProtectedRoute />} >
            <Route path="home/" element={<Home />} Exact>
              <Route index element={<BeginView />} Exact/>
              <Route index path="inicio" element={<BeginView />} Exact/>
              <Route path="user" element={<UserView />} Exact/>
              <Route path="user/asignpermission" element={<HasPermission paths={"user"} element={<AsignPermisse/>}/>} Exact/>
              <Route path="user/userimport" element={<HasPermission paths={"user"} element={<UserImport/>}/>} Exact/>
              <Route path="area" element={<HasPermission paths={"area"} element={<AreaView />}/>} Exact/>
              <Route path="service" element={<HasPermission paths={"service"} element={<ServiceView />}/>} Exact/>
              <Route path="atencion" element={<HasPermission paths={"atencion"} element={<TurnView />}/>} Exact/>
              <Route path="pendiente" element={<HasPermission paths={"pendiente"} element={<Pendiente />}/>} Exact/>
              <Route path="paciente" element={<HasPermission paths={"paciente"} element={<Paciente />}/>} Exact/>
              <Route path="medico" element={<HasPermission paths={"medico"} element={<MedicoView />}/>} Exact/>
              <Route path="office" element={<HasPermission paths={"office"} element={<OfficeView />}/>} Exact/>
              <Route path="modulo" element={<HasPermission paths={"modulo"} element={<ModuleView />}/> } Exact/>
              <Route path="projector" element={<HasPermission paths={"projector"} element={<PantallaView />}/>} Exact/>
              <Route path="dispensador" element={<HasPermission paths={"dispensador"} element={<ExpendedorView />}/>} Exact/>
              <Route path="message" element={<HasPermission paths={"message"} element={<MessageView />}/>} Exact/>
              <Route path="permission" element={<HasPermission paths={"permission"} element={<Permission />}/>} Exact/>
              <Route path="reporthist" element={<HasPermission paths={"reporthist"} element={<InformeHistorico />}/> } Exact />
              <Route path="reporatenmes" element={<HasPermission paths={"reporatenmes"} element={<InformeAtencDia/>}/>} Exact/>
              <Route path="reportdate" element={<HasPermission paths={"reportdate"} element={<InformePeriodos />}/>} Exact/>
              <Route path="reportatenhora" element={<HasPermission paths={"reportatenhora"} element={<InformeAtencHora />}/>} Exact/>
              <Route path="reportpromaten" element={<HasPermission paths={"reportpromaten"} element={<InformePromAtencion/>}/>} Exact/>
              <Route path="reportpromesp" element={<HasPermission paths={"reportpromesp"} element={<InformePromEspera/>}/>} Exact/>
              <Route path="reportpromvist" element={<HasPermission paths={"reportpromvist"} element={<InformePromVisita/>}/>} Exact/>
              <Route path="company" element={<HasPermission paths={"company"} element={<CompanyView/>}/>} Exact/>
              <Route path="uploadimage" element={<HasPermission paths={"uploadimage"} element={<UploadImageView />}/>} Exact/>
              <Route path="uploadimage/profile" element={<HasPermission paths={"uploadimage"} element={<UploadImage/>}/>}/> 
              <Route path="uploadvideo" element={<HasPermission paths={"uploadvideo"} element={<UploadVideoView />}/>} Exact/>
              <Route path="uploadvideo/profile" element={<HasPermission paths={"uploadvideo"} element={<UploadVideo/>}/>}/>   
              <Route path="*" return={<>Ha llegado a una página que no existe</>} />
            </Route>
          </Route>  
        <Route path="*" return={<>Ha llegado a una página que no existe</>} />
      </Routes>
    </Router>
    )
}

export default App
